<template>
  <div>
    <template v-if="$route.path === '/semnav' || $route.path === '/landing/semtel'">
      <Header type="pc" ref="newHeader" :addUseDialog="false" @showDialog="showDialog" />
      <SemtelBanner
        :showForm="!showScrollForm"
        :video="banner.video"
        @msg="handleShowMsg"
        :landingPageName="landingPageName"
        @setShowSuccessDialog="setShowSuccessDialog"
      />
      <SemtelPoints @showDialog="showDialog" :title="painPoints.title" :pointTextList="painPoints.pointTextList" />
      <ModifyProductPower @showDialog="showDialog" :title="ModifyProductPower.title" :powerList="ModifyProductPower.powerList" />
      <OperateStep :title="operateStep.title" :setpList="operateStep.stepList" />
      <SolutionListNew />
    </template>
    <template v-else>
      <SemtelBanner
        :showForm="!showScrollForm"
        :video="banner.video"
        @msg="handleShowMsg"
        :landingPageName="landingPageName"
        @setShowSuccessDialog="setShowSuccessDialog"
      />
      <SemtelPoints @showDialog="showDialog" :title="painPoints.title" :pointTextList="painPoints.pointTextList" />
      <ModifyProductPower @showDialog="showDialog" :title="ModifyProductPower.title" :powerList="ModifyProductPower.powerList" />
      <OperateStep :title="operateStep.title" :setpList="operateStep.stepList" />
      <SolutionList @showDialog="showDialog" :title="solutions.title" :solutionList="solutions.list" />
    </template>
    <Message :type="message.type" :title="message.title" :content="message.content" :show.sync="message.show" />
    <CoreSuperiority :title="superiority.title" :numberList="superiority.numberList" :textList="superiority.textList" />
    <OrgList :title="orgList.title" :orgTypeList="orgList.orgTypeList" :imgs="orgList.imgs" />
    <NumberInfo
      @showDialog="showDialog"
      :title="numberInfo.title"
      :numberList="numberInfo.numberList"
      :qrImgUrl="numberInfo.qrImgUrl"
    ></NumberInfo>
    <ModifyContact @showDialog="showDialog" :landingPageName="landingPageName" />
    <SuccessFrom v-if="showSuccessDialog" @closeform="showSuccessDialog = false" />
    <UseDialog ref="dialog" />
    <Footer />
  </div>
</template>

<script>
import pageMixin from './pageMixin.js'
const pubStr = window.location.search && window.location.search.match(/tsign_source_detail=[^&]+/)
const pub = pubStr && pubStr.length && pubStr[0].split('=')[1]

export default {
  mixins: [pageMixin],
  components: {
    Header: () => import('../../components/header/index.vue'),
    SemtelBanner: () => import('./components/pc/SemtelBanner.vue'),
    // Contact: () => import('./components/pc/Contact.vue'),
    ModifyContact: () => import('./components/pc/ModifyContact.vue'),
    // Ecology: () => import('./components/pc/Ecology.vue'),
    Footer: () => import('./components/pc/Footer.vue'),
    OperateStep: () => import('./components/pc/OperateStep.vue'),
    ModifyProductPower: () => import('./components/pc/ModifyProductPower.vue'),
    SolutionList: () => import('./components/pc/SolutionList.vue'),
    CoreSuperiority: () => import('./components/pc/CoreSuperiority.vue'),
    NumberInfo: () => import('./components/pc/NumberInfo.vue'),
    // LawText: () => import('./components/pc/LawText.vue'),
    // LowCostAccess: () => import('./components/pc/LowCostAccess.vue'),
    Message: () => import('./components/pc/Message.vue'),
    OrgList: () => import('./components/pc/OrgList.vue'),
    SemtelPoints: () => import('./components/pc/SemtelPoints.vue'),
    // Reason: () => import('./components/pc/Reason.vue'),
    // ScrollForm: () => import('./components/pc/ScrollForm.vue'),
    SuccessFrom: () => import('./components/pc/successFrom.vue'),
    UseDialog: () => import('./components/pc/UseDialog.vue'),
    SolutionListNew: () => import('./components/pc/SolutionListNew.vue'),
  },
  data() {
    return {
      UseDialogShow: false,
      showSuccessDialog: false,
      // 落地页名字'e签宝宣传'，因为以上的组件会被多次复用，为了服务商收集数据的时候能够更准确，用这个名字去判断是否需要向服务商发送数据
      landingPageName: 'esignPropagate',
      banner: {
        video: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanre/banner.mp4',
      },
      showScrollForm: false,
      ModifyProductPower: {
        title: '灵活产品与能力',
        powerList: [
          {
            name: '公有云SaaS平台',
            iconUrl: require(`../../assets/images/power1.png`),
            toWho: '适用对象：成长型中小企业',
            descList: [
              '超高性价比选择',
              '开通即用，功能丰富，签管一体',
              '智能AI与电子合同的完美结合',
              '一处发起，多处签署',
              '覆盖PC、微信、支付宝、APP等六大端',
            ],
            link: '免费试用',
            url: 'https://www.baidu.com',
          },
          {
            name: '公有云API开放平台',
            iconUrl: require(`../../assets/images/power2.png`),
            toWho: '适用对象：中大型企业组织',
            descList: [
              '快速集成OA/CRM/SCM/EHR/ERP 等原有业务系统',
              '参数自定义，性能强，商业模式灵活',
              '多种签署体验，覆盖全部行业场景应用',
              '多种对接方案，满足深度融合需求',
              '全程取证、司法机构广泛认可',
            ],
            link: '免费试用',
            url: 'https://www.baidu.com',
          },
          {
            name: '混合云印章平台',
            iconUrl: require(`../../assets/images/power3.png`),
            toWho: '适用对象：集团型企业',
            descList: [
              '科学中立的相对方模型',
              '原文沙箱专利技术，确保隐私安全',
              '私有化部署，核心数据不出网',
              '支持“国产化信创&国际通用” 双重环境规范',
              '物电一体，整合印控仪、电子印章一体化方案',
              '1000+大型组织信息化建设应用沉淀',
            ],
            link: '免费试用',
            url: 'https://www.baidu.com',
          },
          {
            name: '钉钉签名',
            iconUrl: require(`../../assets/images/power4.png`),
            toWho: '适用对象：钉钉平台企业用户',
            descList: ['钉钉原生电子签名官方应用', '与钉钉多项原生功能深度融合', '支持内/外部签署场景', '已服务钉钉平台百万级客户'],
            link: '免费试用',
            url: 'https://www.baidu.com',
          },
        ],
      },
      operateStep: {
        title: '无需邮寄，1分钟完成线上签署',
        stepList: [
          {
            iconUrl: require(`../../assets/images/step1.png`),
            text: '签发合同',
          },
          {
            iconUrl: require(`../../assets/images/step2.png`),
            text: '实名/意愿认证',
          },
          {
            iconUrl: require(`../../assets/images/step3.png`),
            text: '线上签署',
          },
          {
            iconUrl: require(`../../assets/images/step4.png`),
            text: '区块链存档',
          },
        ],
      },
      solutions: {
        title: '行业实践解决方案',
        list: [
          {
            videoUrl: require('../../assets/video/human-resource.mp4'),
            imgUrl: require('../../assets/images/solution1.png'),
            link: '免费试用>',
            text: '人力资源',
            url: 'https://www.baidu.com',
            maskShow: true,
            videoShow: false,
          },
          {
            videoUrl: require('../../assets/video/logistics.mp4'),
            imgUrl: require('../../assets/images/solution2.png'),
            link: '免费试用>',
            text: '物流',
            url: 'https://www.baidu.com',
            maskShow: true,
            videoShow: false,
          },
          {
            videoUrl: require('../../assets/video/bank.mp4'),
            imgUrl: require('../../assets/images/solution3.png'),
            link: '免费试用>',
            text: '银行',
            url: 'https://www.baidu.com',
            maskShow: true,
            videoShow: false,
          },
          {
            videoUrl: require('../../assets/video/car-leasing.mp4'),
            imgUrl: require('../../assets/images/solution4.png'),
            link: '免费试用>',
            text: '汽车',
            url: 'https://www.baidu.com',
            maskShow: true,
            videoShow: false,
          },
          {
            videoUrl: require('../../assets/video/medical.mp4'),
            imgUrl: require('../../assets/images/solution5.png'),
            link: '免费试用>',
            text: '医疗',
            url: 'https://www.baidu.com',
            maskShow: true,
            videoShow: false,
          },
          {
            videoUrl: require('../../assets/video/construction.mp4'),
            imgUrl: require('../../assets/images/solution6.png'),
            link: '免费试用>',
            text: '房地产',
            url: 'https://www.baidu.com',
            maskShow: true,
            videoShow: false,
          },
          {
            videoUrl: require('../../assets/video/e-commerce.mp4'),
            imgUrl: require('../../assets/images/solution7.png'),
            link: '免费试用>',
            text: 'B2B电商',
            url: 'https://www.baidu.com',
            maskShow: true,
            videoShow: false,
          },
          {
            videoUrl: require('../../assets/video/online-education.mp4'),
            imgUrl: require('../../assets/images/solution8.png'),
            link: '免费试用>',
            text: '在线教育',
            url: 'https://www.baidu.com',
            maskShow: true,
            videoShow: false,
          },
        ],
      },
      superiority: {
        title: 'e签宝核心优势',
        numberList: [
          {
            num: '156',
            numText: '著作权',
          },
          {
            num: '20',
            numText: '发明专利',
          },
          {
            num: '2',
            numText: '国家课题',
          },
        ],
        textList: [
          {
            iconUrl: require('../../assets/images/superiority1.png'),
            contitle: '超强服务性能',
            descList: ['超级计算集群：云服务器数量近万台', '日均签署量：2000万次', '平均签署耗时：199ms', '数据可靠性：99.99999%'],
          },
          {
            iconUrl: require('../../assets/images/superiority2.png'),
            contitle: '核心专利技术',
            descList: [
              '原文沙箱保护技术',
              '多时间戳证据固化技术',
              '区块链保全技术',
              '盲数字水印技术',
              '国产算法和版式文件支持',
              '基于分布式密钥的文件安全技术',
            ],
          },
          {
            iconUrl: require('../../assets/images/superiority3.png'),
            contitle: 'AI智能合同',
            descList: [
              '提供智能合同模板，智能层级审批',
              '智能比对，精准率接近100%',
              '合同自动分类，支持批量签署',
              '实时追踪合同进度，智能提醒',
              '智能台账，数据抓取分析',
              '智能印章管理',
            ],
          },
          {
            iconUrl: require('../../assets/images/superiority4.png'),
            contitle: '大型客户应用实践',
            descList: [
              '浙江省"最多跑一次"指定电子签供应商',
              '100+世界五百强客户',
              '200+中国五百强客户',
              '150+ 全国省/市政府客户',
              '1500+政务服务应用',
            ],
          },
          {
            iconUrl: require('../../assets/images/superiority5.png'),
            contitle: '完整生态网络',
            descList: [
              '3000+生态伙伴深度融合',
              'OA：钉钉、蓝凌、致远等',
              'CRM：salesforce 、纷享销客、销帮帮等',
              'EHR：Moka招聘、北森、薪福通、肯耐珂萨等',
              'ERP：SAP、用友、明源等',
            ],
          },
          {
            iconUrl: require('../../assets/images/superiority6.png'),
            contitle: '参与行业标准制定',
            descList: [
              '国家密标委标准化委员会首批成员单位',
              '参与多项国家和地方行业标准制定',
              '《基于云的电子签名服务技术要求》',
              '《电子合同订立流程规范》',
              '《浙江省电子印章标准》',
              '《电子招投标密码应用技术规范》',
            ],
          },
          {
            iconUrl: require('../../assets/images/superiority7.png'),
            contitle: '权威资质认可',
            descList: [
              '商用密码产品认证证书',
              '涉密信息系统产品检测证书',
              '信息系统安全专用产品销售许可证',
              'ISO27001认证',
              'ISO27018认证',
              'ISO27701认证',
            ],
          },
          {
            iconUrl: require('../../assets/images/superiority8.png'),
            contitle: '齐全的法律服务',
            descList: [
              '出具多种类型证据报告',
              '包括司法鉴定意见书、公证书',
              'e签宝全过程证明',
              '提供法律咨询、质证服务',
              '电子证据法律咨询服务',
              '互联网业务流程公证服务',
            ],
          },
        ],
      },
      numberInfo: {
        title: '签合同·用e签宝',
        btnText: '免费试用',
        numberList: ['63.27', '316.34', '5.27'],
        qrImgUrl: require(`../../assets/images/qr-code.png`),
      },
      orgList: {
        title: '客户成功案例',
        orgTypeList: ['人力资源', '地产租房', '互联网+', '银行金融', '零售制造', '汽车物流', '教育旅游', '公共服务'],
        imgs: ['humanRes', 'logistics', 'hlw', 'bank', 'lszz', 'qqwl', 'jjly', 'ggfw'].map((item) => {
          return require(`../../assets/images/${item}.png`)
        }),
      },
      reason: {
        title: '为什么选择e签宝电子签名产品？',
        imgs: new Array(6)
          .fill('')
          .map((img, index) => `https://asset.esign.cn/apps/esign-landing/html/static/imgs/reason/reason${index}.png`),
        centerImg: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/center.png',
        url: `https://h5.esign.cn/usercenterFront/regist?pub=${pub}`,
      },
      painPoints: {
        title: '签署更便捷  信任更简单',
        pointTextList: [
          {
            iconUrl: require(`../../assets/images/arrow-bot.png`),
            text1: '90%',
            text2: '合同管理成本下降90%',
            text3: '打印存储成本下降95%',
            text4: '快递成本平均下降15元/份',
            text5: '印章管控成本下降80%',
            text6: '人力管理成本下降90%',
          },
          {
            iconUrl: require(`../../assets/images/arrow-top.png`),
            text1: '95%',
            text2: '合同签署效率提升95%',
            text3: '纸质合同签署平均2-3天',
            text4: '电子合同签署快至1分钟',
            text5: '批量签署上千份合同',
            text6: '合同线上秒归档/调阅',
          },
          {
            iconUrl: require(`../../assets/images/arrow-top.png`),
            text1: '100%',
            text2: '司法保障能力提升100%',
            text3: '人民法院司法区块链统一平台存证',
            text4: '支持出具司法鉴定意见书、公证书',
            text5: '电子证据法律咨询服务',
            text6: '互联网业务流程公证服务',
          },
        ],
      },
      lowCostAccess: {
        title: 'e签宝电子签名服务已实现超低成本接入',
        list: [
          {
            menuTitle: '企业业务部门',
            mainTitle: '电子签名SaaS服务标准版',
            desc: '借助于e签宝SaaS服务成熟的功能体系，完成从合同起草到签约流程发起、通知发送、完成签署、合同管理的闭环服务。',
            img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/con2tab2_bg1.png',
            url: `https://h5.esign.cn/usercenterFront/regist?pub=${pub}`,
          },
          {
            menuTitle: '对接企业OA、ERP等系统',
            mainTitle: '电子签名SaaS服务专业版',
            desc: '对于需要将合同签署流程与业务平台、内部系统集成的客户，e签宝提供电子签名SaaS服务专业版，开放API接口供客户系统集成，数行代码完成对接开发。',
            img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/con2tab2_bg2.png',
            url: `https://h5.esign.cn/usercenterFront/regist?pub=${pub}`,
          },
          {
            menuTitle: '其它终端用户',
            mainTitle: 'Web、H5、微信小程序等终端',
            desc: 'e签宝支持与WEB、APP、H5、微信/支付宝小程序等多个终端快速集成，电商平台的终端用户们，可以0门槛使用e签宝电子签名服务。',
            img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/common/con2tab2_bg3.png',
            url: `https://h5.dingtalk.com/open-market/share.html?shareGoodsCode=AADDC36E1A648100DE32B90C8ACCCF7F720304142ACB1D5623992C18A8A448F564DB2C60CA1DEAE6&token=5e348cf073e3d73642a728c86d5c1957&shareUid=678A35271A441235&pub=${pub}`,
          },
        ],
      },
      energy: {
        title: 'e签宝提供全生态电子签名服务',
        list: [
          {
            url: 'https://www.esign.cn/prod/e_signature.html',
            title: '电子签名',
            desc: '全程电子化签署，文件在线流转，极大提高文书签署效率',
            img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/dz.png',
            imgSize: '59px 54px',
            hoverImg: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/dz-act.png',
          },
          {
            url: 'https://www.esign.cn/prod/e_contract.html',
            title: '合同管理',
            desc: '合同文件电子化存储，标签分类提升管理效率，一键搜索所见即所得',
            img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/qm.png',
            imgSize: '65px 53px',
            hoverImg: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/qm-act.png',
          },
          {
            url: 'https://www.esign.cn/prod/evidence.html',
            title: '存证保全',
            desc: '电子签名全过程数据存证，证据链条完整可靠，联合蚂蚁区块链，打造行业首个区块链电子劳动合同存证平台',
            img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/cz.png',
            imgSize: '41px 54px',
            hoverImg: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/cz-act.png',
          },
          {
            url: 'https://www.esign.cn/prod/evidence.html',
            title: '法律服务',
            desc: '联合公证处、司法鉴定中心、仲裁委，整合遍布全国的线下律师服务，打造安全无忧的司法保障服务体系',
            img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/ty.png',
            imgSize: '64px 54px',
            hoverImg: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/ty-act.png',
          },
        ],
      },
      message: {
        type: '',
        title: '',
        content: '',
        show: false,
      },
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandle, true)
  },
  methods: {
    showDialog() {
      console.log(this.$refs.dialog)
      this.$refs.dialog.showDialog()
    },
    scrollHandle() {
      console.log('document.documentElement.scrollTop', document.documentElement.scrollTop)
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
      this.showScrollForm = scrollTop >= 2280
      this.$refs.newHeader && this.$refs.newHeader.scrollHandle()
    },
    handleShowMsg({ type, title, content }) {
      this.message.type = type
      this.message.title = title
      this.message.content = content
      this.message.show = true
    },
    setShowSuccessDialog(v) {
      this.showSuccessDialog = v
    },
  },
}
</script>

<style lang="less">
* > img {
  max-width: 100%;
}

a {
  font-size: 1rem;
  color: #333;
}

a:hover,
input.error {
  color: #fa465a;
}

.container {
  width: 1200px\9;
}

@media (min-width: 1200px) {
  .main {
    min-width: 1200px;
  }
}

.banner,
.banner video,
.banner .text,
.banner .text .banner_tabbox .tab_listbox,
.con,
.con1,
.con1 .con1_tab .tab_box,
.con2,
.con2 .con2_tab .tab_box,
.con3,
.con4,
.con6,
.footer {
  min-width: 1200px;
}

.suse {
  position: fixed;
  bottom: 250px;
  left: 0px;
  width: 137px;
  height: 97px;
  background: url('../../assets/images/suse.png') no-repeat;
  background-size: contain;
  cursor: pointer;
  z-index: 999999;
}
.btn {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}
</style>
